import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { dimensionType } from '../../../constants/options.constant';
import { useStore } from '../../../contexts/store-provider';
import { IFormModalProps } from '../../../models/forms/IForm';
import { formatMessage } from '../../../translations/format-message';
import AddDimensionDataForm from '../forms/add-edit-dimension-data-columns-form';
import DefaultModal from '../../../shared-components/modal/default-modal';
import { IAddProcessDimensionData } from '../../../models/forms/IAddProcessDimensionData';
import {
  IAddDimension,
  IUpdateDimension,
} from '../../../models/forms/IAddDimension';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import { AddUpdateDimensionInitialState } from '../../../core/initialState';
import { IDimensionVM } from '../../../models/response/IDimensionResponse';

const AddDimensionData = (props: IFormModalProps) => {
  const { processStore, dimensionStore } = useStore();
  const {
    saveDimensionDataState,
    SaveDimensionDataService,
    resetSaveDimensionDataState,
    AddProcessService,
    UpdateProcessService,
    GetProcessByIdService,
    resetAddUpdateProcessState,
    resetProcessDetail,
    addUpdateProcessState,
    processDetails,
    getProcessDimensionDataState,
    GetProcessDimensionDataService,
    processDimensionData,
    GetAllProcessService,
    allProcessMulitSelectOptions,
    processMulitSelectOptions,
    allFactoryProcess,
  } = processStore;

  const {
    AddDimensionService,
    addUpdateDimensionState,
    UpdateDimensionService,
    GetByDimensionIdService,
    dimensionDetails,
    selectedProcesses,
    resetDimensionDetail,
    resetAddUpdateDimensionState
  } = dimensionStore;
  const initialValues: any = {
    Messages: '',
    Pixel: 0,
    DimensionProcesses: [],
  };

  useEffect(() => {
    GetAllProcessService();
  }, []);

  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered
   * while a dependency of the useEffect has changed.
   */
  useEffect(() => {
    // Reset error state when modal opens to prevent stale error messages
    resetAddUpdateDimensionState();

    if (props.id > 0) {
      GetByDimensionIdService(Number(getTenantIdFromLocalStorage()), props.id);
    } else {
      resetDimensionDetail();
    }
  }, []);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateDimensionState.success) {
      if (props.id > 0) {
        toast.success(formatMessage('updated_success'))
      } else {
        toast.success(formatMessage('added_success'))
      }
      onModalClosed();
    }
  }, [addUpdateDimensionState.success]);
  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessError" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateDimensionState.error) {
      toast.error(formatMessage(addUpdateDimensionState.error));
      resetAddUpdateDimensionState();
    }
  }, [addUpdateDimensionState.error]);

  /**
   * This function adds the Process when "Id < 0" and updates the Existing Process when Id > 0 by providing form values to the
   * correponding function
   */
  const onSubmitForm = (values: any) => {
    var addObj: IAddDimension = {
      TenantId: Number(getTenantIdFromLocalStorage()),
      Messages: values.Messages,
      Pixel: values.Pixel,
      DimensionProcesses: values.DimensionProcesses
    };
    var updateObj: IUpdateDimension = {
      Id: props.id,
      TenantId: Number(getTenantIdFromLocalStorage()),
      Messages: values.Messages,
      Pixel: values.Pixel,
      DimensionProcesses: values.DimensionProcesses
    };
    if (props.id < 0) {
      AddDimensionService(addObj);
    }
    else {
      UpdateDimensionService(updateObj);
      // console.log(updateObj, 'updateObj')
    }
  };

  /**
   * This function closes the pop up modal and reset getProcessdetails, addUpdate Process observables (success, inprogress
   * and error).
   */
  const onModalClosed = () => {
    resetDimensionDetail();
    props.modalClosed();
  };

  return (
    <React.Fragment>
      <DefaultModal
        id={props.id}
        className="dimension-modal"
        addHeader="add_dimension_data"
        updateHeader="update_dimension_data"
        onModalClosed={onModalClosed}
        size="sm"
      // isLoading={
      //   // addUpdateTrayState.inProgress || getAllProductState.inProgress
      // }
      >
        <AddDimensionDataForm
          id={props.id}
          initialValues={dimensionDetails}
          submitHandler={onSubmitForm}
          onModalClosed={onModalClosed}
          isLoading={
            saveDimensionDataState.inProgress ||
            getProcessDimensionDataState.inProgress
          }
          processTypeOptions={dimensionType}
          processDimensionData={processDimensionData}
          processOptions={allFactoryProcess}
          selectedProcesses={selectedProcesses}
        />
      </DefaultModal>
    </React.Fragment>
  );
};

export default observer(AddDimensionData);
